import './App.css';
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import SideSection from './components/SideSection';
import MainView from './components/MainView';
import CategoryProducts from './components/CategoryProducts';
import ProductDetails from './components/ProductDetails';
import Branches from './components/Branches';
import BranchCategories from './components/BranchCategories';
import Search from './components/Search';
import BranchSelector from './components/BranchSelector';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminCategories from './pages/admin/Categories';
import AdminProducts from './pages/admin/Products';
import AdminBranches from './pages/admin/Branches';
import AdminHeroImages from './pages/admin/HeroImages';
import AdminRoute from './components/admin/AdminRoute';
import { trackView } from './utils/viewTracker';

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showBranchSelector, setShowBranchSelector] = useState(false);

  // Check if branch selector should be shown
  useEffect(() => {
    // Don't show on admin pages
    if (location.pathname.startsWith('/admin')) {
      setShowBranchSelector(false);
      return;
    }

    // Show selector every time user visits the home page
    if (location.pathname === '/') {
      setShowBranchSelector(true);
    } else {
      setShowBranchSelector(false);
    }
  }, [location.pathname]);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  // Track views on route changes (only for public pages)
  useEffect(() => {
    if (!location.pathname.startsWith('/admin')) {
      trackView(location.pathname);
    }
  }, [location]);

  const handleBranchSelect = (branchId) => {
    setShowBranchSelector(false);
    if (branchId) {
      localStorage.setItem('selectedBranchId', branchId.toString());
    } else {
      // User skipped - clear selected branch but don't set dismissed flag
      // so it shows again next time they visit home page
      localStorage.removeItem('selectedBranchId');
    }
  };

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={
          <>
          <SideSection />
          <MainView />
          </>
        } />
        <Route path="/search" element={
          <>
          <SideSection />
          <Search />
          </>
        } />
        <Route path="/branches" element={
          <>
          <SideSection />
          <Branches />
          </>
        } />
        <Route path="/branch/:branchId" element={
          <>
          <SideSection />
          <BranchCategories />
          </>
        } />
        <Route path="/branch/:branchId/category/:category" element={
          <>
          <SideSection />
          <CategoryProducts />
          </>
        } />
        <Route path="/branch/:branchId/category/:category/product/:productId" element={
          <>
          <SideSection className="hide-on-product-details" />
          <ProductDetails />
          </>
        } />
        <Route path="/:category" element={
          <>
          <SideSection />
          <CategoryProducts />
          </>
        } />
        <Route path="/:category/product/:productId" element={
          <>
          <SideSection className="hide-on-product-details" />
          <ProductDetails />
          </>
        } />
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/admin/categories" element={<AdminRoute><AdminCategories /></AdminRoute>} />
        <Route path="/admin/products" element={<AdminRoute><AdminProducts /></AdminRoute>} />
        <Route path="/admin/branches" element={<AdminRoute><AdminBranches /></AdminRoute>} />
        <Route path="/admin/hero-images" element={<AdminRoute><AdminHeroImages /></AdminRoute>} />
      </Routes>
    </div>
  );
}


export default App;
